import { ReactNode } from "react";
import { MainContainer } from "@/components/MainContainer";
import { Card, H3, ScrollArea, Text } from "@focal/ui-kit";
import { cn } from "@/lib/utils";

interface AddMeetingLayoutProps {
  /** Page title — rendered as visual H3, semantic h1. */
  title: string;
  /** Optional subtitle — rendered as P2 secondary text. */
  subtitle?: string;
  /** Page-specific form/CTA content. Stacked vertically with `space-y-4`. */
  children: ReactNode;
  /** Optional extra class names appended to the inner card. */
  className?: string;
}

export const AddMeetingLayout = ({
  title,
  subtitle,
  children,
  className,
}: AddMeetingLayoutProps) => {
  return (
    <MainContainer innerClassName="transition-all p-0!">
      <ScrollArea className="flex flex-1 min-h-0">
        <div className="grid min-h-full grid-rows-[1fr_auto_1.4fr] p-6 lg:py-12">
          <Card
            className={cn(
              "row-start-2 mx-auto flex flex-col w-full max-w-2xl p-6 lg:p-8 items-center text-center",
              className,
            )}
          >
            <H3 as="h1" spacing="none" className="whitespace-pre-wrap">
              {title}
            </H3>
            {subtitle ? (
              <Text
                variant="p2"
                textColor="secondary"
                className="mt-2 max-w-lg"
              >
                {subtitle}
              </Text>
            ) : null}
            <div className="flex flex-col items-center w-full mt-6 space-y-4">
              {children}
            </div>
          </Card>
        </div>
      </ScrollArea>
    </MainContainer>
  );
};
